import { createStore } from 'satcheljs';
import YammerDeeplinkStore from './schema/YammerDeeplinkStore';

export default createStore<YammerDeeplinkStore>('yammerDeeplinkStore', {
    deeplinkThreadId: '',
})();
